import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Import English translation files
import enCommon from './locales/en/common.json';
import enForms from './locales/en/forms.json';
import enDashboard from './locales/en/dashboard.json';
import enMembership from './locales/en/membership.json';
import enAthletes from './locales/en/athletes.json';
import enMessages from './locales/en/messages.json';
import enModals from './locales/en/modals.json';
import enOnboarding from './locales/en/onboarding.json';
import enAdmin from './locales/en/admin.json';

// Import Spanish translation files
import esCommon from './locales/es/common.json';
import esForms from './locales/es/forms.json';
import esDashboard from './locales/es/dashboard.json';
import esMembership from './locales/es/membership.json';
import esAthletes from './locales/es/athletes.json';
import esMessages from './locales/es/messages.json';
import esModals from './locales/es/modals.json';
import esOnboarding from './locales/es/onboarding.json';
import esAdmin from './locales/es/admin.json';

export const SUPPORTED_LANGUAGES = ['en', 'es'] as const;
export type SupportedLanguage = typeof SUPPORTED_LANGUAGES[number];

export const LANGUAGE_NAMES: Record<SupportedLanguage, string> = {
  en: 'English',
  es: 'Español',
};

const resources = {
  en: {
    common: enCommon,
    forms: enForms,
    dashboard: enDashboard,
    membership: enMembership,
    athletes: enAthletes,
    messages: enMessages,
    modals: enModals,
    onboarding: enOnboarding,
    admin: enAdmin,
  },
  es: {
    common: esCommon,
    forms: esForms,
    dashboard: esDashboard,
    membership: esMembership,
    athletes: esAthletes,
    messages: esMessages,
    modals: esModals,
    onboarding: esOnboarding,
    admin: esAdmin,
  },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en',
    defaultNS: 'common',
    ns: ['common', 'forms', 'dashboard', 'membership', 'athletes', 'messages', 'modals', 'onboarding', 'admin'],

    detection: {
      order: ['localStorage', 'navigator', 'htmlTag'],
      lookupLocalStorage: 'language',
      caches: ['localStorage'],
    },

    interpolation: {
      escapeValue: false, // React already escapes by default
    },

    react: {
      useSuspense: true,
    },
  });

export default i18n;
